"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ui_theme_1 = require("@kyruus/ui-theme");
const intl_1 = require("@kyruus/intl");
const prop_types_1 = require("prop-types");
const gmap_1 = __importDefault(require("@kyruus/gmap"));
const aws_map_1 = require("@kyruus/aws-map");
const button_1 = __importDefault(require("@kyruus/button"));
const messages_1 = __importDefault(require("../../lib/messages"));
const Locations_1 = __importDefault(require("./Locations"));
const styles_1 = require("./styles");
const ProviderLocations_utils_1 = require("./ProviderLocations.utils");
const gmapUtils = __importStar(require("./ProviderLocations.gmap.utils"));
const awsUtils = __importStar(require("./ProviderLocations.aws.utils"));
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
const propTypes = {
    bookableLocations: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
        id: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
        name: prop_types_1.string,
        street1: prop_types_1.string,
        street2: prop_types_1.string,
        suite: prop_types_1.string,
        city: prop_types_1.string,
        state: prop_types_1.string,
        zip: prop_types_1.string
    })).isRequired,
    nonBookableLocations: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
        id: prop_types_1.string,
        name: prop_types_1.string,
        street1: prop_types_1.string,
        street2: prop_types_1.string,
        suite: prop_types_1.string,
        city: prop_types_1.string,
        state: prop_types_1.string,
        zip: prop_types_1.string
    })).isRequired,
    /**
     * location on select handler
     * @callback
     * @param {Object} props
     * @param {Set} props.selectedLocationIds all currently selected location ids
     */
    onSelect: prop_types_1.func.isRequired,
    /**
     * Injected by `injectIntl HOC`
     */
    intl: (0, prop_types_1.shape)({
        locale: prop_types_1.string.isRequired,
        formatMessage: prop_types_1.func.isRequired
    }).isRequired,
    selectedLocationIds: (0, prop_types_1.instanceOf)(Set).isRequired,
    highlightedLocId: prop_types_1.string,
    url: prop_types_1.string,
    config: prop_types_1.object.isRequired,
    awsMapConfig: prop_types_1.object
};
/**
 * ┌──────────────────────────┐
 * │                          │
 * │            Map           │
 * │                          │
 * ├──────────────────────────┤
 * │ ┌─┐ ┌──────────────────┐ │
 * │ │X│ │     Location     │ │
 * │ └─┘ └──────────────────┘ │
 * ├──────────────────────────┤
 * │ ┌─┐ ┌──────────────────┐ │
 * │ │X│ │    Location      │ │
 * │ └─┘ └──────────────────┘ │
 * ├──────────────────────────┤
 * │     ┌──────────────────┐ │
 * │     │    Location      │ │
 * │     └──────────────────┘ │
 * └──────────────────────────┘
 */
const ProviderLocations = (0, ui_theme_1.withTheme)(({ theme, bookableLocations, nonBookableLocations, onSelect, intl, selectedLocationIds, highlightedLocId = null, url = '', locationId, className, mapEventsToRegister, config, awsMapConfig }) => {
    var _a;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const [showMap, setShowMap] = (0, react_1.useState)(aboveMd);
    const [showToggleMap, setShowToggleMap] = (0, react_1.useState)(false);
    const [activeListLocId, setActiveListLocId] = (0, react_1.useState)();
    const markersRef = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        setShowToggleMap(!aboveMd);
        if (aboveMd) {
            setShowMap(true);
        }
    }, [aboveMd]);
    (0, react_1.useEffect)(() => {
        setActiveListLocId(highlightedLocId);
    }, [highlightedLocId, setActiveListLocId]);
    const handleSelectLocation = (id) => {
        onSelect((0, ProviderLocations_utils_1.toggleLocationInSet)(selectedLocationIds, id), id);
    };
    // Event handlers
    const handleMarkerMouseout = (0, react_1.useCallback)(() => {
        setActiveListLocId(null);
    }, [setActiveListLocId]);
    const handleMarkerMouseover = (0, react_1.useCallback)(({ meta }) => {
        setActiveListLocId(meta.location.id);
    }, [setActiveListLocId]);
    const handleGetMarkers = (0, react_1.useCallback)((markers) => {
        var _a;
        markersRef.current = markers;
        if (((_a = config.maps_config) === null || _a === void 0 ? void 0 : _a.location_service_provider) === 'aws') {
            awsUtils.updateNonBookableMarkers(markers, nonBookableLocations);
        }
        else {
            gmapUtils.updateNonBookableMarkers(markers, nonBookableLocations, theme);
        }
    }, [markersRef, nonBookableLocations, theme, config]);
    const handleLocationMouseEnter = (0, react_1.useCallback)((id) => {
        var _a;
        setActiveListLocId(id);
        // https://healthsparq.atlassian.net/browse/KENG-41045
        if (((_a = config.maps_config) === null || _a === void 0 ? void 0 : _a.location_service_provider) === 'aws') {
            awsUtils.animateLocationMarker(markersRef.current, id);
        }
        else {
            gmapUtils.animateLocationMarker(markersRef.current, id);
        }
    }, [setActiveListLocId, markersRef, config]);
    const handleLocationMouseLeave = (0, react_1.useCallback)(() => {
        var _a;
        setActiveListLocId(null);
        // https://healthsparq.atlassian.net/browse/KENG-41045
        if (((_a = config.maps_config) === null || _a === void 0 ? void 0 : _a.location_service_provider) === 'aws') {
            awsUtils.clearMarkerAnimation(markersRef.current);
        }
        else {
            gmapUtils.clearMarkerAnimation(markersRef.current);
        }
    }, [setActiveListLocId, markersRef, config]);
    const mapLocations = [].concat(bookableLocations, nonBookableLocations);
    const handleOnFocus = (0, react_1.useCallback)((id) => {
        setActiveListLocId(id);
    }, []);
    const handleOnBlur = (0, react_1.useCallback)(() => {
        setActiveListLocId(null);
    }, []);
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "ProviderLocations", className: className },
        react_1.default.createElement(styles_1.Header, null,
            !aboveMd && react_1.default.createElement("h5", null, "Available Locations"),
            showToggleMap && (react_1.default.createElement(button_1.default, { onClick: () => setShowMap(!showMap), mode: "flat" }, showMap ? (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.hideMap))) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.showMap)))))),
        react_1.default.createElement(styles_1.Body, { className: "ProviderLocationsBody" },
            showMap && (react_1.default.createElement(styles_1.MapContainer, { className: "MapContainer" }, ((_a = config.maps_config) === null || _a === void 0 ? void 0 : _a.location_service_provider) === 'aws' ? (react_1.default.createElement(aws_map_1.AwsMap, { locations: mapLocations.map((loc) => (Object.assign(Object.assign({}, loc), { isDisabled: !selectedLocationIds.has(loc.id) }))), mapEventsToRegister: mapEventsToRegister, awsMapConfig: awsMapConfig, getMarkers: handleGetMarkers })) : (react_1.default.createElement(gmap_1.default, { "aria-label": intl.formatMessage(messages_1.default.ariamapcontainer), enabledLocationIds: selectedLocationIds, url: url, locations: mapLocations, getMarkers: handleGetMarkers, onMarkerMouseout: handleMarkerMouseout, onMarkerMouseover: handleMarkerMouseover, mapEventsToRegister: mapEventsToRegister })))),
            react_1.default.createElement(Locations_1.default, { bookableLocations: bookableLocations, nonBookableLocations: nonBookableLocations, onSelect: handleSelectLocation, selectedLocationIds: selectedLocationIds, onMouseEnter: handleLocationMouseEnter, onMouseLeave: handleLocationMouseLeave, handleOnFocus: handleOnFocus, handleOnBlur: handleOnBlur, activeLocationId: activeListLocId, locationId: locationId }))));
});
ProviderLocations.defaultProps = { url: '', highlightedLocId: null };
ProviderLocations.propTypes = propTypes;
exports.default = (0, intl_1.injectIntl)(ProviderLocations);
//# sourceMappingURL=ProviderLocations.js.map